module.exports = __webpack_public_path__ + "media/images/CO_angellist-03140644.svg";